<template>
  <TemplateBase :page="page">
    <!-- Slot with back button with flush false so it is positioned to the header -->
    <template #backButton>
      <MoleculeButtonBreadcrumbBack
        :breadcrumbs="breadcrumbs"
        :background-color="page.__typename === 'page_education_Entry' ? 'bg-app-secondary-7-violet--purple-heart' : undefined"
      />
    </template>

    <div
      class="grid grid-cols-12"
      :class="{ 'bg-white sm:bg-transparent': page.__typename === 'page_page_Entry', 'v-gradient-bg v-gradient-bg--violet': page.__typename === 'page_education_Entry' }"
    >
      <section
        v-if="page.image"
        class="col-span-full row-start-1 z-0 v-margin-page-image-to-page-content"
        :class="{ 'bg-white sm:bg-transparent': page.__typename === 'page_page_Entry', 'bg-transparent': page.__typename === 'page_education_Entry' }"
      >
        <MoleculeMaskVisual :image="page.image" :image-is-decorative="page.imageIsDecorative" />
      </section>

      <OrganismPageSectionContent
        class="row-start-2 col-span-full mb-8 md:mb-12 xl:mb-16 2xl:mb-20"
        :at-page-top="!page.image"
        :title="page.title"
        :subtitle="page.subtitle"
        :introduction="page.introduction"
        :description="page.description"
        :background-color="page.__typename === 'page_education_Entry' ? 'bg-transparent sm:bg-white' : undefined"
        :theme="page.__typename === 'page_education_Entry' ? 'violet' : undefined"
        :mobile-theme="page.__typename === 'page_education_Entry' ? 'white' : undefined"
      />

      <MoleculeMatrix
        class="relative z-10 row-start-3 col-span-full"
        :items="page.dynamicContent"
        :color-theme="page.__typename === 'page_education_Entry' ? 'violet' : undefined"
        :mobile-theme="page.__typename === 'page_education_Entry' ? 'white' : undefined"
        :background-color="page.__typename === 'page_education_Entry' ? 'bg-transparent sm:bg-white' : undefined"
      />
    </div>
  </TemplateBase>
</template>

<script setup lang="ts">
defineProps({
  breadcrumbs: { type: Array as PropType<any[]>, required: true },
  page: { type: Object as PropType<Record<string, any>>, required: true },
})
</script>
